export default __webpack_public_path__ + "media/icatu_214px_172px-03.png";